import { makeApiCallWithAny } from "./tokenService";
import { ICodeTitle } from "../models/common/codeTitle";

export const getTimezones = (signal: AbortSignal): Promise<ICodeTitle[]> => {
    return makeApiCallWithAny("api/timezone", signal);
};
